import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Row, Col, Form, Badge } from "react-bootstrap";
import Draggable from "react-draggable";
import { toast } from "react-toastify";
import schoolApi from "../../api/schoolApi";
import moment from "moment";

import { getDefaultTemplate } from "../../utils/idCardHelper";

// 4 Professional Starter Layout Presets for both Vertical (54x86) and Horizontal (86x54)
const getPresetTemplate = (styleName = "classic", orientation = "vertical", defaultHeaderColor = "#d1b2b2", defaultTextColor = "#faf4f4") => {
  if (styleName === "table_sage") {
    if (orientation === "vertical") {
      return {
        orientation: "vertical",
        width: 54,
        height: 86,
        background: { color: "#ffffff", image: "" },
        elements: [
          {
            id: "top_sage_banner",
            type: "shape",
            label: "Top Header Banner",
            x: 0,
            y: 0,
            width: 54,
            height: 23,
            backgroundColor: "#a2cac0",
            borderColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            zIndex: 1,
          },
          {
            id: "school_logo",
            type: "image",
            fieldKey: "schoolLogo",
            label: "School Logo",
            x: 21,
            y: 1.5,
            width: 12,
            height: 12,
            borderWidth: 1,
            borderColor: "#22332e",
            borderRadius: 50,
            zIndex: 2,
          },
          {
            id: "school_name",
            type: "field",
            fieldKey: "schoolName",
            label: "School Name",
            x: 2,
            y: 14,
            width: 50,
            height: 4.5,
            fontSize: 12,
            fontWeight: "bold",
            color: "#1b2e28",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "school_address",
            type: "field",
            fieldKey: "schoolAddress",
            label: "School Address",
            x: 2,
            y: 18.2,
            width: 50,
            height: 5.5,
            fontSize: 6.5,
            fontWeight: "normal",
            color: "#1b2e28",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "session_text",
            type: "field",
            fieldKey: "session",
            label: "Session",
            x: 15,
            y: 23.5,
            width: 24,
            height: 3,
            fontSize: 7.5,
            fontWeight: "bold",
            color: "#1b2e28",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "profile_image",
            type: "image",
            fieldKey: "profileImage",
            label: "Student Photo",
            x: 16,
            y: 26.5,
            width: 22,
            height: 22,
            borderWidth: 2,
            borderColor: "#2d6cf0",
            borderRadius: 50,
            zIndex: 3,
          },
          {
            id: "student_name",
            type: "field",
            fieldKey: "studentName",
            label: "Student Name",
            x: 2,
            y: 49.5,
            width: 50,
            height: 4.5,
            fontSize: 12,
            fontWeight: "bold",
            color: "#222222",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "class_row",
            type: "field",
            fieldKey: "fullClass",
            label: "Class Row",
            prefix: "Class : ",
            x: 3.5,
            y: 54.5,
            width: 47,
            height: 4.2,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#333333",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            borderWidthBottom: 0.5,
            borderColor: "#e5e7eb",
            zIndex: 3,
          },
          {
            id: "father_row",
            type: "field",
            fieldKey: "fatherName",
            label: "Father Name Row",
            prefix: "Father's Name : ",
            x: 3.5,
            y: 59,
            width: 47,
            height: 4.2,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#333333",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            borderWidthBottom: 0.5,
            borderColor: "#e5e7eb",
            zIndex: 3,
          },
          {
            id: "dob_row",
            type: "field",
            fieldKey: "registerDate",
            label: "DOB Row",
            prefix: "D.O.B : ",
            x: 3.5,
            y: 63.5,
            width: 47,
            height: 4.2,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#333333",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            borderWidthBottom: 0.5,
            borderColor: "#e5e7eb",
            zIndex: 3,
          },
          {
            id: "phone_row",
            type: "field",
            fieldKey: "phone",
            label: "Contact Row",
            prefix: "Contact No. : ",
            x: 3.5,
            y: 68,
            width: 47,
            height: 4.2,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#333333",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            borderWidthBottom: 0.5,
            borderColor: "#e5e7eb",
            zIndex: 3,
          },
          {
            id: "address_row",
            type: "field",
            fieldKey: "studentAddress",
            label: "Student Address Row",
            prefix: "Address : ",
            x: 3.5,
            y: 72.5,
            width: 47,
            height: 7,
            fontSize: 7.5,
            fontWeight: "normal",
            color: "#333333",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "bottom_sage_banner",
            type: "shape",
            label: "Bottom Footer Banner",
            x: 0,
            y: 80,
            width: 54,
            height: 6,
            backgroundColor: "#a2cac0",
            borderColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            zIndex: 1,
          },
          {
            id: "reg_no_footer",
            type: "field",
            fieldKey: "registrationNo",
            label: "Registration No",
            x: 3,
            y: 81.2,
            width: 24,
            height: 4,
            fontSize: 8.5,
            fontWeight: "bold",
            color: "#111827",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "principal_sign_text",
            type: "text",
            text: "Principal Sign.",
            label: "Principal Sign",
            x: 27,
            y: 81.2,
            width: 24,
            height: 4,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#111827",
            textAlign: "right",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
        ],
      };
    } else {
      // Horizontal version of Sage Table layout (86x54)
      return {
        orientation: "horizontal",
        width: 86,
        height: 54,
        background: { color: "#ffffff", image: "" },
        elements: [
          {
            id: "left_sage_banner",
            type: "shape",
            label: "Left Header Panel",
            x: 0,
            y: 0,
            width: 28,
            height: 54,
            backgroundColor: "#a2cac0",
            borderColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            zIndex: 1,
          },
          {
            id: "school_logo",
            type: "image",
            fieldKey: "schoolLogo",
            label: "School Logo",
            x: 8,
            y: 3,
            width: 12,
            height: 12,
            borderWidth: 1,
            borderColor: "#22332e",
            borderRadius: 50,
            zIndex: 2,
          },
          {
            id: "profile_image",
            type: "image",
            fieldKey: "profileImage",
            label: "Student Photo",
            x: 4,
            y: 17,
            width: 20,
            height: 20,
            borderWidth: 2,
            borderColor: "#2d6cf0",
            borderRadius: 50,
            zIndex: 3,
          },
          {
            id: "session_text",
            type: "field",
            fieldKey: "session",
            label: "Session",
            x: 2,
            y: 38.5,
            width: 24,
            height: 4,
            fontSize: 8,
            fontWeight: "bold",
            color: "#1b2e28",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "reg_no_footer",
            type: "field",
            fieldKey: "registrationNo",
            label: "Registration No",
            x: 2,
            y: 45,
            width: 24,
            height: 4,
            fontSize: 8,
            fontWeight: "bold",
            color: "#111827",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "school_name",
            type: "field",
            fieldKey: "schoolName",
            label: "School Name",
            x: 30,
            y: 3,
            width: 53,
            height: 5,
            fontSize: 12,
            fontWeight: "bold",
            color: "#1b2e28",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "school_address",
            type: "field",
            fieldKey: "schoolAddress",
            label: "School Address",
            x: 30,
            y: 8.5,
            width: 53,
            height: 5,
            fontSize: 6.5,
            fontWeight: "normal",
            color: "#1b2e28",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "student_name",
            type: "field",
            fieldKey: "studentName",
            label: "Student Name",
            x: 30,
            y: 14.5,
            width: 53,
            height: 5,
            fontSize: 13,
            fontWeight: "bold",
            color: "#222222",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "class_row",
            type: "field",
            fieldKey: "fullClass",
            label: "Class Row",
            prefix: "Class : ",
            x: 30,
            y: 20.5,
            width: 53,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#333333",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            borderWidthBottom: 0.5,
            borderColor: "#e5e7eb",
            zIndex: 3,
          },
          {
            id: "father_row",
            type: "field",
            fieldKey: "fatherName",
            label: "Father Name Row",
            prefix: "Father's Name : ",
            x: 30,
            y: 25.5,
            width: 53,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#333333",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            borderWidthBottom: 0.5,
            borderColor: "#e5e7eb",
            zIndex: 3,
          },
          {
            id: "dob_row",
            type: "field",
            fieldKey: "registerDate",
            label: "DOB Row",
            prefix: "D.O.B : ",
            x: 30,
            y: 30.5,
            width: 53,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#333333",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            borderWidthBottom: 0.5,
            borderColor: "#e5e7eb",
            zIndex: 3,
          },
          {
            id: "phone_row",
            type: "field",
            fieldKey: "phone",
            label: "Contact Row",
            prefix: "Contact No. : ",
            x: 30,
            y: 35.5,
            width: 53,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#333333",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            borderWidthBottom: 0.5,
            borderColor: "#e5e7eb",
            zIndex: 3,
          },
          {
            id: "address_row",
            type: "field",
            fieldKey: "studentAddress",
            label: "Student Address Row",
            prefix: "Address : ",
            x: 30,
            y: 40.5,
            width: 53,
            height: 7,
            fontSize: 7.5,
            fontWeight: "normal",
            color: "#333333",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "principal_sign_text",
            type: "text",
            text: "Principal Sign.",
            label: "Principal Sign",
            x: 60,
            y: 48,
            width: 23,
            height: 4,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#111827",
            textAlign: "right",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
        ],
      };
    }
  }

  if (styleName === "classic") {
    return getDefaultTemplate(orientation, defaultHeaderColor, defaultTextColor);
  }

  if (styleName === "minimalist") {
    if (orientation === "vertical") {
      return {
        orientation: "vertical",
        width: 54,
        height: 86,
        background: { color: "#ffffff", image: "" },
        elements: [
          {
            id: "school_name",
            type: "field",
            fieldKey: "schoolName",
            label: "School Name",
            x: 2,
            y: 3,
            width: 50,
            height: 6,
            fontSize: 11,
            fontWeight: "bold",
            color: defaultHeaderColor,
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "school_address",
            type: "field",
            fieldKey: "schoolAddress",
            label: "School Address",
            x: 2,
            y: 9,
            width: 50,
            height: 4.5,
            fontSize: 7,
            fontWeight: "normal",
            color: "#64748b",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "top_divider",
            type: "shape",
            label: "Top Divider",
            x: 4,
            y: 14.5,
            width: 46,
            height: 0.4,
            backgroundColor: "#cbd5e1",
            borderColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            zIndex: 1,
          },
          {
            id: "profile_image",
            type: "image",
            fieldKey: "profileImage",
            label: "Student Photo",
            x: 14,
            y: 17,
            width: 26,
            height: 30,
            borderWidth: 1,
            borderColor: "#cbd5e1",
            borderRadius: 8,
            zIndex: 3,
          },
          {
            id: "class_badge",
            type: "field",
            fieldKey: "fullClass",
            label: "Class Badge",
            prefix: "CLASS ",
            x: 12,
            y: 48.5,
            width: 30,
            height: 5,
            fontSize: 8,
            fontWeight: "bold",
            color: defaultTextColor,
            textAlign: "center",
            backgroundColor: defaultHeaderColor,
            borderRadius: 12,
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "student_name",
            type: "field",
            fieldKey: "studentName",
            label: "Student Name",
            x: 2,
            y: 55,
            width: 50,
            height: 6,
            fontSize: 13,
            fontWeight: "bold",
            color: "#0f172a",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "reg_no",
            type: "field",
            fieldKey: "registrationNo",
            label: "Registration No",
            prefix: "ID Number: ",
            x: 2,
            y: 61,
            width: 50,
            height: 4,
            fontSize: 8,
            fontWeight: "normal",
            color: "#64748b",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "father_name",
            type: "field",
            fieldKey: "fatherName",
            label: "Father's Name",
            prefix: "Father: ",
            x: 5,
            y: 67,
            width: 44,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#334155",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "phone_field",
            type: "field",
            fieldKey: "phone",
            label: "Contact No",
            prefix: "Contact: ",
            x: 5,
            y: 72,
            width: 44,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#334155",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "bottom_divider",
            type: "shape",
            label: "Bottom Divider",
            x: 4,
            y: 78.5,
            width: 46,
            height: 0.4,
            backgroundColor: "#cbd5e1",
            borderColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            zIndex: 1,
          },
          {
            id: "school_phone",
            type: "field",
            fieldKey: "schoolPhone",
            label: "School Phone",
            x: 4,
            y: 80,
            width: 46,
            height: 4.5,
            fontSize: 7.5,
            fontWeight: "normal",
            color: "#64748b",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
        ],
      };
    } else {
      // Horizontal Minimalist (86x54)
      return {
        orientation: "horizontal",
        width: 86,
        height: 54,
        background: { color: "#ffffff", image: "" },
        elements: [
          {
            id: "school_logo",
            type: "image",
            fieldKey: "schoolLogo",
            label: "School Logo",
            x: 4,
            y: 3,
            width: 10,
            height: 10,
            borderWidth: 0,
            borderColor: "transparent",
            borderRadius: 0,
            zIndex: 2,
          },
          {
            id: "school_name",
            type: "field",
            fieldKey: "schoolName",
            label: "School Name",
            x: 16,
            y: 3,
            width: 66,
            height: 6,
            fontSize: 12,
            fontWeight: "bold",
            color: defaultHeaderColor,
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "school_address",
            type: "field",
            fieldKey: "schoolAddress",
            label: "School Address",
            x: 16,
            y: 9,
            width: 66,
            height: 4,
            fontSize: 7,
            fontWeight: "normal",
            color: "#64748b",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "top_divider",
            type: "shape",
            label: "Top Divider",
            x: 4,
            y: 14.5,
            width: 78,
            height: 0.4,
            backgroundColor: "#cbd5e1",
            borderColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            zIndex: 1,
          },
          {
            id: "profile_image",
            type: "image",
            fieldKey: "profileImage",
            label: "Student Photo",
            x: 5,
            y: 17,
            width: 25,
            height: 28,
            borderWidth: 1,
            borderColor: "#cbd5e1",
            borderRadius: 8,
            zIndex: 3,
          },
          {
            id: "class_badge",
            type: "field",
            fieldKey: "fullClass",
            label: "Class Badge",
            prefix: "CLASS ",
            x: 5,
            y: 46.5,
            width: 25,
            height: 4.5,
            fontSize: 7.5,
            fontWeight: "bold",
            color: defaultTextColor,
            textAlign: "center",
            backgroundColor: defaultHeaderColor,
            borderRadius: 10,
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "student_name",
            type: "field",
            fieldKey: "studentName",
            label: "Student Name",
            x: 34,
            y: 17,
            width: 48,
            height: 6,
            fontSize: 13,
            fontWeight: "bold",
            color: "#0f172a",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "reg_no",
            type: "field",
            fieldKey: "registrationNo",
            label: "Registration No",
            prefix: "ID Number: ",
            x: 34,
            y: 24,
            width: 48,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#64748b",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "father_name",
            type: "field",
            fieldKey: "fatherName",
            label: "Father's Name",
            prefix: "Father: ",
            x: 34,
            y: 30,
            width: 48,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#334155",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "dob_field",
            type: "field",
            fieldKey: "registerDate",
            label: "Date of Birth",
            prefix: "DOB: ",
            x: 34,
            y: 35.5,
            width: 48,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#334155",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "phone_field",
            type: "field",
            fieldKey: "phone",
            label: "Contact No",
            prefix: "Contact: ",
            x: 34,
            y: 41,
            width: 48,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#334155",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
        ],
      };
    }
  }

  if (styleName === "sidepanel") {
    if (orientation === "vertical") {
      return {
        orientation: "vertical",
        width: 54,
        height: 86,
        background: { color: "#ffffff", image: "" },
        elements: [
          {
            id: "left_sidebar",
            type: "shape",
            label: "Left Sidebar",
            x: 0,
            y: 0,
            width: 14,
            height: 86,
            backgroundColor: defaultHeaderColor,
            borderColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            zIndex: 1,
          },
          {
            id: "school_logo",
            type: "image",
            fieldKey: "schoolLogo",
            label: "School Logo",
            x: 1.5,
            y: 4,
            width: 11,
            height: 11,
            borderWidth: 1,
            borderColor: "#ffffff",
            borderRadius: 50,
            zIndex: 2,
          },
          {
            id: "reg_no",
            type: "field",
            fieldKey: "registrationNo",
            label: "Registration No",
            x: 1,
            y: 18,
            width: 12,
            height: 12,
            fontSize: 7.5,
            fontWeight: "bold",
            color: defaultTextColor,
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "school_name",
            type: "field",
            fieldKey: "schoolName",
            label: "School Name",
            x: 16,
            y: 4,
            width: 36,
            height: 8,
            fontSize: 10,
            fontWeight: "bold",
            color: "#0f172a",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "school_address",
            type: "field",
            fieldKey: "schoolAddress",
            label: "School Address",
            x: 16,
            y: 12,
            width: 36,
            height: 5,
            fontSize: 6.5,
            fontWeight: "normal",
            color: "#64748b",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "profile_image",
            type: "image",
            fieldKey: "profileImage",
            label: "Student Photo",
            x: 19,
            y: 19,
            width: 30,
            height: 30,
            borderWidth: 2,
            borderColor: defaultHeaderColor,
            borderRadius: 6,
            zIndex: 3,
          },
          {
            id: "student_name",
            type: "field",
            fieldKey: "studentName",
            label: "Student Name",
            x: 16,
            y: 51,
            width: 36,
            height: 6,
            fontSize: 12,
            fontWeight: "bold",
            color: "#0f172a",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "class_field",
            type: "field",
            fieldKey: "fullClass",
            label: "Class & Section",
            prefix: "Class: ",
            x: 17,
            y: 58,
            width: 34,
            height: 5,
            fontSize: 8.5,
            fontWeight: "bold",
            color: "#334155",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "father_name",
            type: "field",
            fieldKey: "fatherName",
            label: "Father's Name",
            prefix: "Father: ",
            x: 17,
            y: 63.5,
            width: 34,
            height: 5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#334155",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "dob_field",
            type: "field",
            fieldKey: "registerDate",
            label: "Date of Birth",
            prefix: "DOB: ",
            x: 17,
            y: 69,
            width: 34,
            height: 5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#334155",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "phone_field",
            type: "field",
            fieldKey: "phone",
            label: "Contact No",
            prefix: "Phone: ",
            x: 17,
            y: 74.5,
            width: 34,
            height: 5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#334155",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "principal_sign",
            type: "text",
            label: "Principal Sign.",
            text: "Principal Sign.",
            x: 24,
            y: 80.5,
            width: 28,
            height: 4.5,
            fontSize: 7.5,
            fontWeight: "normal",
            color: "#64748b",
            textAlign: "right",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
        ],
      };
    } else {
      // Horizontal Side-Panel (86x54)
      return {
        orientation: "horizontal",
        width: 86,
        height: 54,
        background: { color: "#ffffff", image: "" },
        elements: [
          {
            id: "left_sidebar",
            type: "shape",
            label: "Left Sidebar",
            x: 0,
            y: 0,
            width: 26,
            height: 54,
            backgroundColor: defaultHeaderColor,
            borderColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            zIndex: 1,
          },
          {
            id: "school_logo",
            type: "image",
            fieldKey: "schoolLogo",
            label: "School Logo",
            x: 6.5,
            y: 4,
            width: 13,
            height: 13,
            borderWidth: 2,
            borderColor: "#ffffff",
            borderRadius: 50,
            zIndex: 2,
          },
          {
            id: "school_name",
            type: "field",
            fieldKey: "schoolName",
            label: "School Name",
            x: 1,
            y: 19,
            width: 24,
            height: 8,
            fontSize: 9,
            fontWeight: "bold",
            color: defaultTextColor,
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "session_text",
            type: "field",
            fieldKey: "session",
            label: "Session",
            x: 1,
            y: 28,
            width: 24,
            height: 5,
            fontSize: 7.5,
            fontWeight: "bold",
            color: defaultTextColor,
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "reg_no",
            type: "field",
            fieldKey: "registrationNo",
            label: "Registration No",
            prefix: "ID: ",
            x: 1,
            y: 43,
            width: 24,
            height: 5,
            fontSize: 8,
            fontWeight: "bold",
            color: defaultTextColor,
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "profile_image",
            type: "image",
            fieldKey: "profileImage",
            label: "Student Photo",
            x: 30,
            y: 6,
            width: 22,
            height: 26,
            borderWidth: 1,
            borderColor: "#cbd5e1",
            borderRadius: 6,
            zIndex: 3,
          },
          {
            id: "student_name",
            type: "field",
            fieldKey: "studentName",
            label: "Student Name",
            x: 55,
            y: 6,
            width: 29,
            height: 6,
            fontSize: 13,
            fontWeight: "bold",
            color: "#0f172a",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "class_field",
            type: "field",
            fieldKey: "fullClass",
            label: "Class & Section",
            prefix: "Class: ",
            x: 55,
            y: 13.5,
            width: 29,
            height: 5,
            fontSize: 9,
            fontWeight: "bold",
            color: defaultHeaderColor,
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "father_name",
            type: "field",
            fieldKey: "fatherName",
            label: "Father's Name",
            prefix: "Father: ",
            x: 55,
            y: 19.5,
            width: 29,
            height: 4.5,
            fontSize: 8,
            fontWeight: "normal",
            color: "#334155",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "dob_field",
            type: "field",
            fieldKey: "registerDate",
            label: "Date of Birth",
            prefix: "DOB: ",
            x: 55,
            y: 25,
            width: 29,
            height: 4.5,
            fontSize: 8,
            fontWeight: "normal",
            color: "#334155",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "phone_field",
            type: "field",
            fieldKey: "phone",
            label: "Contact No",
            prefix: "Emergency Contact: ",
            x: 30,
            y: 35,
            width: 54,
            height: 5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#334155",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "school_address",
            type: "field",
            fieldKey: "schoolAddress",
            label: "School Address",
            x: 30,
            y: 41.5,
            width: 54,
            height: 4.5,
            fontSize: 7,
            fontWeight: "normal",
            color: "#64748b",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "principal_sign",
            type: "text",
            label: "Principal Sign.",
            text: "Principal Sign.",
            x: 60,
            y: 47,
            width: 24,
            height: 4.5,
            fontSize: 7.5,
            fontWeight: "normal",
            color: "#64748b",
            textAlign: "right",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
        ],
      };
    }
  }

  if (styleName === "gradient_banner") {
    if (orientation === "vertical") {
      return {
        orientation: "vertical",
        width: 54,
        height: 86,
        background: { color: "#ffffff", image: "" },
        elements: [
          {
            id: "header_top",
            type: "shape",
            label: "Top Banner",
            x: 0,
            y: 0,
            width: 54,
            height: 28,
            backgroundColor: defaultHeaderColor,
            borderColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            zIndex: 1,
          },
          {
            id: "accent_stripe",
            type: "shape",
            label: "Accent Line",
            x: 0,
            y: 28,
            width: 54,
            height: 2.5,
            backgroundColor: "#f59e0b",
            borderColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            zIndex: 2,
          },
          {
            id: "school_logo",
            type: "image",
            fieldKey: "schoolLogo",
            label: "School Logo",
            x: 2.5,
            y: 3,
            width: 10,
            height: 10,
            borderWidth: 1,
            borderColor: "#ffffff",
            borderRadius: 50,
            zIndex: 2,
          },
          {
            id: "school_name",
            type: "field",
            fieldKey: "schoolName",
            label: "School Name",
            x: 13.5,
            y: 3.5,
            width: 38,
            height: 8,
            fontSize: 11,
            fontWeight: "bold",
            color: defaultTextColor,
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "session_text",
            type: "field",
            fieldKey: "session",
            label: "Session",
            x: 13.5,
            y: 12,
            width: 38,
            height: 5,
            fontSize: 8,
            fontWeight: "bold",
            color: defaultTextColor,
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "profile_image",
            type: "image",
            fieldKey: "profileImage",
            label: "Student Photo",
            x: 14.5,
            y: 18,
            width: 25,
            height: 25,
            borderWidth: 3,
            borderColor: "#ffffff",
            borderRadius: 50,
            zIndex: 3,
          },
          {
            id: "student_name",
            type: "field",
            fieldKey: "studentName",
            label: "Student Name",
            x: 2,
            y: 45.5,
            width: 50,
            height: 6,
            fontSize: 13,
            fontWeight: "bold",
            color: "#111827",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "reg_no",
            type: "field",
            fieldKey: "registrationNo",
            label: "Registration No",
            prefix: "ID: ",
            x: 2,
            y: 52,
            width: 50,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "bold",
            color: "#f59e0b",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "class_field",
            type: "field",
            fieldKey: "fullClass",
            label: "Class & Section",
            prefix: "Class: ",
            x: 5,
            y: 58.5,
            width: 44,
            height: 4.5,
            fontSize: 9,
            fontWeight: "normal",
            color: "#374151",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "father_name",
            type: "field",
            fieldKey: "fatherName",
            label: "Father's Name",
            prefix: "Father: ",
            x: 5,
            y: 63.5,
            width: 44,
            height: 4.5,
            fontSize: 9,
            fontWeight: "normal",
            color: "#374151",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "dob_field",
            type: "field",
            fieldKey: "registerDate",
            label: "Date of Birth",
            prefix: "DOB: ",
            x: 5,
            y: 68.5,
            width: 44,
            height: 4.5,
            fontSize: 9,
            fontWeight: "normal",
            color: "#374151",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "bottom_banner",
            type: "shape",
            label: "Bottom Banner",
            x: 0,
            y: 78,
            width: 54,
            height: 8,
            backgroundColor: "#1e293b",
            borderColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            zIndex: 1,
          },
          {
            id: "phone_field",
            type: "field",
            fieldKey: "phone",
            label: "Contact No",
            prefix: "Emergency Phone: ",
            x: 2,
            y: 79.5,
            width: 50,
            height: 5,
            fontSize: 8,
            fontWeight: "bold",
            color: "#ffffff",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
        ],
      };
    } else {
      // Horizontal Gradient Banner (86x54)
      return {
        orientation: "horizontal",
        width: 86,
        height: 54,
        background: { color: "#ffffff", image: "" },
        elements: [
          {
            id: "header_top",
            type: "shape",
            label: "Top Banner",
            x: 0,
            y: 0,
            width: 86,
            height: 16,
            backgroundColor: defaultHeaderColor,
            borderColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            zIndex: 1,
          },
          {
            id: "accent_stripe",
            type: "shape",
            label: "Accent Line",
            x: 0,
            y: 16,
            width: 86,
            height: 2,
            backgroundColor: "#f59e0b",
            borderColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            zIndex: 2,
          },
          {
            id: "school_logo",
            type: "image",
            fieldKey: "schoolLogo",
            label: "School Logo",
            x: 3,
            y: 2,
            width: 12,
            height: 12,
            borderWidth: 1,
            borderColor: "#ffffff",
            borderRadius: 50,
            zIndex: 2,
          },
          {
            id: "school_name",
            type: "field",
            fieldKey: "schoolName",
            label: "School Name",
            x: 17,
            y: 3,
            width: 66,
            height: 6,
            fontSize: 12,
            fontWeight: "bold",
            color: defaultTextColor,
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "session_text",
            type: "field",
            fieldKey: "session",
            label: "Session",
            x: 17,
            y: 9.5,
            width: 66,
            height: 5,
            fontSize: 8,
            fontWeight: "bold",
            color: defaultTextColor,
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "profile_image",
            type: "image",
            fieldKey: "profileImage",
            label: "Student Photo",
            x: 6,
            y: 11,
            width: 24,
            height: 24,
            borderWidth: 3,
            borderColor: "#ffffff",
            borderRadius: 50,
            zIndex: 3,
          },
          {
            id: "reg_no",
            type: "field",
            fieldKey: "registrationNo",
            label: "Registration No",
            prefix: "ID: ",
            x: 3,
            y: 36.5,
            width: 30,
            height: 4.5,
            fontSize: 8,
            fontWeight: "bold",
            color: "#f59e0b",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "student_name",
            type: "field",
            fieldKey: "studentName",
            label: "Student Name",
            x: 34,
            y: 20,
            width: 50,
            height: 6,
            fontSize: 13,
            fontWeight: "bold",
            color: "#111827",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "class_field",
            type: "field",
            fieldKey: "fullClass",
            label: "Class & Section",
            prefix: "Class: ",
            x: 34,
            y: 27,
            width: 50,
            height: 5,
            fontSize: 9.5,
            fontWeight: "bold",
            color: "#374151",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "father_name",
            type: "field",
            fieldKey: "fatherName",
            label: "Father's Name",
            prefix: "Father: ",
            x: 34,
            y: 32.5,
            width: 50,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#374155",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "dob_field",
            type: "field",
            fieldKey: "registerDate",
            label: "Date of Birth",
            prefix: "DOB: ",
            x: 34,
            y: 37.5,
            width: 50,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#374155",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "bottom_banner",
            type: "shape",
            label: "Bottom Banner",
            x: 0,
            y: 46,
            width: 86,
            height: 8,
            backgroundColor: "#1e293b",
            borderColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            zIndex: 1,
          },
          {
            id: "phone_field",
            type: "field",
            fieldKey: "phone",
            label: "Contact No",
            prefix: "Emergency Phone: ",
            x: 4,
            y: 47.5,
            width: 78,
            height: 5,
            fontSize: 8,
            fontWeight: "bold",
            color: "#ffffff",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
        ],
      };
    }
  }

  if (styleName === "hex_gold") {
    if (orientation === "vertical") {
      return {
        orientation: "vertical",
        width: 54,
        height: 86,
        background: { color: "#ffffff", image: "" },
        elements: [
          {
            id: "header_navy",
            type: "shape",
            label: "Top Navy Header",
            x: 0,
            y: 0,
            width: 54,
            height: 26,
            backgroundColor: "#0f172a",
            borderColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            zIndex: 1,
          },
          {
            id: "school_logo",
            type: "image",
            fieldKey: "schoolLogo",
            label: "School Logo",
            x: 22,
            y: 2.5,
            width: 10,
            height: 10,
            borderWidth: 1.5,
            borderColor: "#f59e0b",
            borderRadius: 50,
            zIndex: 2,
          },
          {
            id: "school_name",
            type: "field",
            fieldKey: "schoolName",
            label: "School Name",
            x: 2,
            y: 13.5,
            width: 50,
            height: 6,
            fontSize: 10,
            fontWeight: "bold",
            color: "#f59e0b",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "session_text",
            type: "field",
            fieldKey: "session",
            label: "Session",
            x: 2,
            y: 19.5,
            width: 50,
            height: 4,
            fontSize: 7,
            fontWeight: "normal",
            color: "#e2e8f0",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "profile_image",
            type: "image",
            fieldKey: "profileImage",
            label: "Gold Framed Photo",
            x: 13,
            y: 26,
            width: 28,
            height: 28,
            borderWidth: 3,
            borderColor: "#d97706",
            borderRadius: 10,
            zIndex: 3,
          },
          {
            id: "student_name",
            type: "field",
            fieldKey: "studentName",
            label: "Student Name",
            x: 2,
            y: 56,
            width: 50,
            height: 6,
            fontSize: 13,
            fontWeight: "bold",
            color: "#d97706",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "class_field",
            type: "field",
            fieldKey: "fullClass",
            label: "Class & Section",
            prefix: "Major / Class: ",
            x: 2,
            y: 62,
            width: 50,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "bold",
            color: "#334155",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "reg_no",
            type: "field",
            fieldKey: "registrationNo",
            label: "Registration No",
            prefix: "ID No        : ",
            x: 6,
            y: 68,
            width: 44,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "bold",
            color: "#1e293b",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "father_name",
            type: "field",
            fieldKey: "fatherName",
            label: "Father's Name",
            prefix: "Father Name: ",
            x: 6,
            y: 72.5,
            width: 44,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#334155",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "phone_field",
            type: "field",
            fieldKey: "phone",
            label: "Contact No",
            prefix: "Phone       : ",
            x: 6,
            y: 77,
            width: 44,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#334155",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "school_phone",
            type: "field",
            fieldKey: "schoolPhone",
            label: "School Phone",
            prefix: "Contact   : ",
            x: 6,
            y: 81.5,
            width: 44,
            height: 4.5,
            fontSize: 8,
            fontWeight: "normal",
            color: "#334155",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
        ],
      };
    } else {
      // Horizontal Hex Gold (86x54)
      return {
        orientation: "horizontal",
        width: 86,
        height: 54,
        background: { color: "#ffffff", image: "" },
        elements: [
          {
            id: "header_navy",
            type: "shape",
            label: "Top Navy Header",
            x: 0,
            y: 0,
            width: 86,
            height: 16,
            backgroundColor: "#0f172a",
            borderColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            zIndex: 1,
          },
          {
            id: "school_logo",
            type: "image",
            fieldKey: "schoolLogo",
            label: "School Logo",
            x: 4,
            y: 3,
            width: 10,
            height: 10,
            borderWidth: 1.5,
            borderColor: "#f59e0b",
            borderRadius: 50,
            zIndex: 2,
          },
          {
            id: "school_name",
            type: "field",
            fieldKey: "schoolName",
            label: "School Name",
            x: 16,
            y: 3.5,
            width: 66,
            height: 6,
            fontSize: 11,
            fontWeight: "bold",
            color: "#f59e0b",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "session_text",
            type: "field",
            fieldKey: "session",
            label: "Session",
            x: 16,
            y: 10,
            width: 66,
            height: 4.5,
            fontSize: 7.5,
            fontWeight: "normal",
            color: "#e2e8f0",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "profile_image",
            type: "image",
            fieldKey: "profileImage",
            label: "Gold Framed Photo",
            x: 6,
            y: 19,
            width: 26,
            height: 26,
            borderWidth: 3,
            borderColor: "#d97706",
            borderRadius: 8,
            zIndex: 3,
          },
          {
            id: "student_name",
            type: "field",
            fieldKey: "studentName",
            label: "Student Name",
            x: 36,
            y: 19,
            width: 48,
            height: 6,
            fontSize: 13,
            fontWeight: "bold",
            color: "#d97706",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "class_field",
            type: "field",
            fieldKey: "fullClass",
            label: "Class & Section",
            prefix: "Class: ",
            x: 36,
            y: 26,
            width: 48,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "bold",
            color: "#334155",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "reg_no",
            type: "field",
            fieldKey: "registrationNo",
            label: "Registration No",
            prefix: "ID No: ",
            x: 36,
            y: 31.5,
            width: 48,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "bold",
            color: "#1e293b",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "phone_field",
            type: "field",
            fieldKey: "phone",
            label: "Contact No",
            prefix: "Phone: ",
            x: 36,
            y: 37,
            width: 48,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#334155",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "father_name",
            type: "field",
            fieldKey: "fatherName",
            label: "Father's Name",
            prefix: "Father: ",
            x: 36,
            y: 42.5,
            width: 48,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#334155",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
          {
            id: "school_phone",
            type: "field",
            fieldKey: "schoolPhone",
            label: "School Phone",
            x: 4,
            y: 48,
            width: 78,
            height: 4.5,
            fontSize: 7.5,
            fontWeight: "normal",
            color: "#64748b",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
        ],
      };
    }
  }

  if (styleName === "dual_gold") {
    if (orientation === "vertical") {
      return {
        orientation: "vertical",
        width: 54,
        height: 86,
        background: { color: "#ffffff", image: "" },
        elements: [
          {
            id: "top_navy_block",
            type: "shape",
            label: "Top Navy Block",
            x: 0,
            y: 0,
            width: 54,
            height: 50,
            backgroundColor: "#0f172a",
            borderColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            zIndex: 1,
          },
          {
            id: "school_logo",
            type: "image",
            fieldKey: "schoolLogo",
            label: "School Logo",
            x: 3,
            y: 3,
            width: 11,
            height: 11,
            borderWidth: 1.5,
            borderColor: "#f59e0b",
            borderRadius: 50,
            zIndex: 2,
          },
          {
            id: "school_name",
            type: "field",
            fieldKey: "schoolName",
            label: "School Name",
            x: 15,
            y: 4,
            width: 37,
            height: 6,
            fontSize: 10,
            fontWeight: "bold",
            color: "#f59e0b",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "session_text",
            type: "field",
            fieldKey: "session",
            label: "Session",
            x: 15,
            y: 10.5,
            width: 37,
            height: 4.5,
            fontSize: 7,
            fontWeight: "normal",
            color: "#cbd5e1",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "student_name",
            type: "field",
            fieldKey: "studentName",
            label: "Student Name",
            x: 3,
            y: 17,
            width: 48,
            height: 6,
            fontSize: 13,
            fontWeight: "bold",
            color: "#f59e0b",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "class_field",
            type: "field",
            fieldKey: "fullClass",
            label: "Department / Class",
            prefix: "Department/Class: ",
            x: 3,
            y: 24,
            width: 48,
            height: 5,
            fontSize: 8.5,
            fontWeight: "bold",
            color: "#ffffff",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "reg_no",
            type: "field",
            fieldKey: "registrationNo",
            label: "Registration No",
            prefix: "ID No      : ",
            x: 3,
            y: 31,
            width: 48,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#38bdf8",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "dob_field",
            type: "field",
            fieldKey: "registerDate",
            label: "Date of Birth / Joined",
            prefix: "Joined Date: ",
            x: 3,
            y: 36.5,
            width: 48,
            height: 4.5,
            fontSize: 8,
            fontWeight: "normal",
            color: "#ffffff",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "phone_field",
            type: "field",
            fieldKey: "phone",
            label: "Contact No",
            prefix: "Contact    : ",
            x: 3,
            y: 42,
            width: 48,
            height: 4.5,
            fontSize: 8,
            fontWeight: "normal",
            color: "#ffffff",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "profile_image",
            type: "image",
            fieldKey: "profileImage",
            label: "Gold Framed Photo",
            x: 12,
            y: 52,
            width: 30,
            height: 26,
            borderWidth: 3,
            borderColor: "#d97706",
            borderRadius: 4,
            zIndex: 3,
          },
          {
            id: "barcode_strip",
            type: "shape",
            label: "Barcode Box",
            x: 4,
            y: 80,
            width: 46,
            height: 4.5,
            backgroundColor: "#334155",
            borderColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            zIndex: 2,
          },
          {
            id: "principal_sign",
            type: "text",
            label: "Visual Barcode",
            text: "||| |||| | ||||| |||| | ||||| ||| ||||",
            x: 4,
            y: 80.5,
            width: 46,
            height: 4,
            fontSize: 8,
            fontWeight: "normal",
            color: "#ffffff",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
        ],
      };
    } else {
      // Horizontal Dual Gold (86x54)
      return {
        orientation: "horizontal",
        width: 86,
        height: 54,
        background: { color: "#ffffff", image: "" },
        elements: [
          {
            id: "left_navy_block",
            type: "shape",
            label: "Left Navy Panel",
            x: 0,
            y: 0,
            width: 52,
            height: 54,
            backgroundColor: "#0f172a",
            borderColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            zIndex: 1,
          },
          {
            id: "school_logo",
            type: "image",
            fieldKey: "schoolLogo",
            label: "School Logo",
            x: 3,
            y: 4,
            width: 11,
            height: 11,
            borderWidth: 1.5,
            borderColor: "#f59e0b",
            borderRadius: 50,
            zIndex: 2,
          },
          {
            id: "school_name",
            type: "field",
            fieldKey: "schoolName",
            label: "School Name",
            x: 15.5,
            y: 5,
            width: 35,
            height: 6,
            fontSize: 10,
            fontWeight: "bold",
            color: "#f59e0b",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "session_text",
            type: "field",
            fieldKey: "session",
            label: "Session",
            x: 15.5,
            y: 11,
            width: 35,
            height: 4.5,
            fontSize: 7,
            fontWeight: "normal",
            color: "#cbd5e1",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "student_name",
            type: "field",
            fieldKey: "studentName",
            label: "Student Name",
            x: 4,
            y: 18,
            width: 46,
            height: 6,
            fontSize: 12.5,
            fontWeight: "bold",
            color: "#f59e0b",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "class_field",
            type: "field",
            fieldKey: "fullClass",
            label: "Department / Class",
            prefix: "Department/Class: ",
            x: 4,
            y: 25,
            width: 46,
            height: 5,
            fontSize: 8.5,
            fontWeight: "bold",
            color: "#ffffff",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "reg_no",
            type: "field",
            fieldKey: "registrationNo",
            label: "Registration No",
            prefix: "ID No           : ",
            x: 4,
            y: 32,
            width: 46,
            height: 4.5,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#38bdf8",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "dob_field",
            type: "field",
            fieldKey: "registerDate",
            label: "Date of Birth / Joined",
            prefix: "Joined Date : ",
            x: 4,
            y: 37.5,
            width: 46,
            height: 4.5,
            fontSize: 8,
            fontWeight: "normal",
            color: "#ffffff",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "phone_field",
            type: "field",
            fieldKey: "phone",
            label: "Contact No",
            prefix: "Contact No  : ",
            x: 4,
            y: 43,
            width: 46,
            height: 4.5,
            fontSize: 8,
            fontWeight: "normal",
            color: "#ffffff",
            textAlign: "left",
            fontFamily: "Arial, sans-serif",
            zIndex: 2,
          },
          {
            id: "profile_image",
            type: "image",
            fieldKey: "profileImage",
            label: "Gold Framed Photo",
            x: 55,
            y: 5,
            width: 28,
            height: 35,
            borderWidth: 3.5,
            borderColor: "#d97706",
            borderRadius: 4,
            zIndex: 3,
          },
          {
            id: "barcode_strip",
            type: "shape",
            label: "Barcode Box",
            x: 54,
            y: 45,
            width: 30,
            height: 6,
            backgroundColor: "#334155",
            borderColor: "transparent",
            borderWidth: 0,
            borderRadius: 0,
            zIndex: 2,
          },
          {
            id: "principal_sign",
            type: "text",
            label: "Visual Barcode",
            text: "||| |||| | ||||| |||| | ||||| ||| ||||",
            x: 54,
            y: 46,
            width: 30,
            height: 4,
            fontSize: 8.5,
            fontWeight: "normal",
            color: "#ffffff",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            zIndex: 3,
          },
        ],
      };
    }
  }

  return getDefaultTemplate(orientation, defaultHeaderColor, defaultTextColor);
};

const IdCardDesignerModal = ({
  show,
  onHide,
  settingsList = [],
  studentList = [],
  userInfo = {},
  initialOrientation = "vertical",
  onSaveSuccess,
}) => {
  const [orientation, setOrientation] = useState(initialOrientation);
  const [activePresetStyle, setActivePresetStyle] = useState("classic");
  const [template, setTemplate] = useState(() => getPresetTemplate("classic", initialOrientation));
  const [selectedElementId, setSelectedElementId] = useState(null);
  const [previewStudentIndex, setPreviewStudentIndex] = useState(0);
  const [previewEntityType, setPreviewEntityType] = useState("student"); // "student" or "staff"
  const [staffList, setStaffList] = useState([]);
  const [zoom, setZoom] = useState(3.8); // scale factor: 1mm = 3.8px on screen
  const [isSaving, setIsSaving] = useState(false);
  const fileInputRef = useRef(null);

  // Extract default color settings
  const colorSetting = settingsList.find((s) => s.key === "id_card_color")?.value || "#d1b2b2";
  const textColorSetting = settingsList.find((s) => s.key === "id_card_text_color")?.value || "#faf4f4";

  // Load existing saved template from settings on open or when orientation switches
  useEffect(() => {
    if (!show) return;
    schoolApi.fetchStaffContacts().then(res => {
      const list = Array.isArray(res) ? res : res.contacts || res.data || [];
      const updatedList = list.map(staff => {
        if (staff.profile_image?.data) {
          try {
            const uint8Array = new Uint8Array(staff.profile_image.data);
            const blob = new Blob([uint8Array], { type: "image/png" });
            staff.profileImageUrl = URL.createObjectURL(blob);
          } catch (e) {}
        }
        return staff;
      });
      setStaffList(updatedList);
    }).catch(err => console.error("Error fetching staff for preview:", err));

    const settingKey = orientation === "vertical" ? "id_card_template_vertical" : "id_card_template_horizontal";
    const foundSetting = settingsList.find((s) => s.key === settingKey);

    if (foundSetting && foundSetting.value && foundSetting.value.trim().startsWith("{")) {
      try {
        const parsed = JSON.parse(foundSetting.value);
        if (parsed.elements && Array.isArray(parsed.elements)) {
          setTemplate(parsed);
          setSelectedElementId(parsed.elements[0]?.id || null);
          return;
        }
      } catch (e) {
        console.warn("Failed to parse existing ID card template from settings, loading preset:", e);
      }
    }
    const defaultTpl = getPresetTemplate(activePresetStyle, orientation, colorSetting, textColorSetting);
    setTemplate(defaultTpl);
    setSelectedElementId(defaultTpl.elements[0]?.id || null);
  }, [show, orientation]); // Only run when modal opens or orientation switches so dropdown choices are not overwritten

  // Current sample student data
  const currentStudent = previewEntityType === "student" ? (studentList[previewStudentIndex] || {}) : (staffList[previewStudentIndex] || {});
  const studentInfo = currentStudent.student_info || currentStudent || {};

  // Resolve dynamic field value for preview
  const getFieldValue = (fieldKey, element) => {
    switch (fieldKey) {
      case "studentName":
        if (previewEntityType === "staff") return studentInfo.staffname || studentInfo.firstname ? `${studentInfo.firstname || ""} ${studentInfo.lastname || ""}`.trim() : "Sample Staff Name";
        return studentInfo.studentname || (studentInfo.firstname ? `${studentInfo.firstname || ""} ${studentInfo.lastname || ""}`.trim() : "Sample Student Name");
      case "registrationNo":
        if (previewEntityType === "staff") return studentInfo.employee_id || (studentInfo.id ? `EMP-${studentInfo.id.split("-")[0].toUpperCase()}` : "EMP-SAMPLE");
        return studentInfo.registration_no || studentInfo.srno || studentInfo.formno || "REG-SAMPLE";
      case "fatherName":
        if (previewEntityType === "staff") return studentInfo.qualification || studentInfo.department || studentInfo.recordtype || "-";
        return studentInfo.parentname || studentInfo.fathername || "Sample Father";
      case "dob":
      case "registerDate":
        return studentInfo.dateofbirth
          ? moment(studentInfo.dateofbirth).format("DD-MM-YYYY")
          : "01-01-2000";
      case "phone":
        return studentInfo.phone || studentInfo.parentmobile || studentInfo.mobile || "9876543210";
      case "studentAddress":
        return studentInfo.street || studentInfo.address || studentInfo.current_address || studentInfo.permanent_address || studentInfo.city || "Sample Address";
      case "fullClass": {
        if (previewEntityType === "staff") return studentInfo.designation || studentInfo.recordtype || "Staff / Employee";
        const className = studentInfo.class_name || "Class";
        const sectionName = studentInfo.section_name || "A";
        return sectionName ? `${className} [${sectionName}]` : className;
      }
      case "designation":
      case "recordtype":
        return previewEntityType === "staff" ? (studentInfo.designation || "Senior Teacher [Maths]") : "-";
      case "qualification":
      case "department":
        return previewEntityType === "staff" ? (studentInfo.qualification || "M.Sc. B.Ed") : "-";
      case "bloodGroup":
        return studentInfo.blood_group || studentInfo.bloodgroup || "-";
      case "session":
        return studentInfo.session || studentInfo.session_year || "2026-2027";
      case "adharnumber":
        return studentInfo.adharnumber || studentInfo.aadhar_no || "1234-5678-9012";
      case "gender":
        return studentInfo.gender || "Male";
      case "category":
        return studentInfo.category || "General";
      case "srno":
        return studentInfo.srno || "SR-001";
      case "email":
        return studentInfo.email || "student@school.com";
      case "city":
        return studentInfo.city || "Jaipur";
      case "religion":
        return studentInfo.religion || "Hindu";
      case "schoolName":
        return userInfo?.companyname || "I BIRDS INTERNATIONAL SCHOOL";
      case "schoolAddress":
        return `${userInfo?.companystreet || "Civil Lines"}, ${userInfo?.companystate || "Ajmer"} ${userInfo?.companypincode || "305001"}`;
      case "schoolPhone":
        return userInfo?.companyphone || userInfo?.phone || "0145-2626262";
      default:
        return element.text || element.label || "Sample Text";
    }
  };

  // Profile image URL resolver
  const getProfileImageUrl = () => {
    if (previewEntityType === "staff" && studentInfo.profileImageUrl) {
      return studentInfo.profileImageUrl;
    }
    
    const ts = Date.now();
    const pid = studentInfo.file_parent_id;
    const fid = studentInfo.file_id;
    const ftype = studentInfo.file_type;
    const tenantcode = userInfo?.tenantcode;
    if (pid && fid && ftype) {
      return `/uploads/${tenantcode}/${pid}/${fid}.${ftype}?v=${ts}`;
    }
    return "/uploads/dwps_ajmer/image_2024102442318.png";
  };

  const getLogoUrl = () => {
    return `/${userInfo?.tenantcode || "dwps_ajmer"}-sidebar-logo.png`;
  };

  const handleElementPropertyChange = (property, value) => {
    if (!selectedElementId) return;
    setTemplate((prev) => ({
      ...prev,
      elements: prev.elements.map((el) =>
        el.id === selectedElementId ? { ...el, [property]: value } : el
      ),
    }));
  };

  const handleElementPropertiesChange = (updates) => {
    if (!selectedElementId) return;
    setTemplate((prev) => ({
      ...prev,
      elements: prev.elements.map((el) =>
        el.id === selectedElementId ? { ...el, ...updates } : el
      ),
    }));
  };

  const handleAddElement = (type, fieldKey = "", label = "New Element") => {
    const newId = `el_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
    let defaultPrefix = "";
    if (activePresetStyle === "table_sage" || activePresetStyle === "classic") {
      if (fieldKey === "fullClass") defaultPrefix = "Class : ";
      else if (fieldKey === "fatherName") defaultPrefix = "Father's Name : ";
      else if (fieldKey === "registerDate" || fieldKey === "dob") defaultPrefix = "D.O.B : ";
      else if (fieldKey === "phone") defaultPrefix = "Contact No. : ";
      else if (fieldKey === "studentAddress") defaultPrefix = "Address : ";
      else if (fieldKey === "bloodGroup") defaultPrefix = "Blood Group : ";
      else if (fieldKey === "adharnumber") defaultPrefix = "Aadhar No. : ";
      else if (fieldKey === "email") defaultPrefix = "Email : ";
      else if (fieldKey === "designation" || fieldKey === "recordtype") defaultPrefix = "Role : ";
      else if (fieldKey === "qualification" || fieldKey === "department") defaultPrefix = "Dept/Qual : ";
    }

    const isTableRow = activePresetStyle === "table_sage" && type === "field" && !["schoolName", "schoolAddress", "studentName", "session", "registrationNo"].includes(fieldKey);
    const isSignature = fieldKey === "principalSignature" || label?.toLowerCase().includes("principal");
    const isCustomImage = fieldKey === "customImage";

    const newElement = {
      id: newId,
      type,
      fieldKey,
      label,
      entityTarget: "all",
      text: type === "text" ? label : "",
      prefix: defaultPrefix,
      x: isTableRow ? (orientation === "vertical" ? 3.5 : 30) : 10,
      y: 10,
      width: type === "shape" ? 40 : isSignature ? 25 : type === "image" ? 20 : (isTableRow ? (orientation === "vertical" ? 47 : 53) : 35),
      height: type === "shape" ? 10 : isSignature ? 10 : type === "image" ? 20 : (fieldKey === "studentAddress" ? 7 : 4.5),
      fontSize: isTableRow ? 8.5 : 10,
      fontWeight: "normal",
      color: isTableRow ? "#333333" : "#222222",
      textAlign: "left",
      fontFamily: "Arial, sans-serif",
      backgroundColor: type === "shape" ? colorSetting : "transparent",
      borderColor: (type === "image" && !isSignature && !isCustomImage) ? "#2d6cf0" : (isTableRow ? "#e5e7eb" : "transparent"),
      borderWidth: (type === "image" && !isSignature && !isCustomImage) ? 2 : 0,
      borderWidthBottom: isTableRow && fieldKey !== "studentAddress" ? 0.5 : 0,
      borderRadius: (type === "image" && !isSignature && !isCustomImage) ? 50 : 0,
      zIndex: template.elements.length + 1,
    };
    setTemplate((prev) => ({
      ...prev,
      elements: [...prev.elements, newElement],
    }));
    setSelectedElementId(newId);
  };

  const handleDeleteElement = (id) => {
    setTemplate((prev) => ({
      ...prev,
      elements: prev.elements.filter((el) => el.id !== id),
    }));
    if (selectedElementId === id) {
      setSelectedElementId(null);
    }
  };

  const handleDragStop = (id, e, data) => {
    // Convert px delta to mm
    const newX = Math.round((data.x / zoom) * 10) / 10;
    const newY = Math.round((data.y / zoom) * 10) / 10;
    setTemplate((prev) => ({
      ...prev,
      elements: prev.elements.map((el) =>
        el.id === id ? { ...el, x: Math.max(0, newX), y: Math.max(0, newY) } : el
      ),
    }));
  };

  const handleSaveToBackend = async () => {
    setIsSaving(true);
    try {
      const settingKey = orientation === "vertical" ? "id_card_template_vertical" : "id_card_template_horizontal";
      const settingDescription = orientation === "vertical" ? "ID Card Vertical Template Schema" : "ID Card Horizontal Template Schema";

      const existingRecord = settingsList.find((s) => s.key === settingKey);
      const existingActiveRecord = settingsList.find((s) => s.key === "id_card_active_orientation");

      const payloadItem = {
        id: existingRecord?.id || null,
        key: settingKey,
        value: JSON.stringify(template),
        isenabled: true,
        description: settingDescription,
      };

      const activeOrientationPayload = {
        id: existingActiveRecord?.id || null,
        key: "id_card_active_orientation",
        value: orientation,
        isenabled: true,
        description: "Active ID Card Orientation for Printing",
      };

      const result = await schoolApi.updateallSettings([payloadItem, activeOrientationPayload]);
      if (result.success || result) {
        toast.success(`ID Card (${orientation.toUpperCase()}) design saved and set as active printing layout!`);
        if (onSaveSuccess) {
          onSaveSuccess(settingKey, JSON.stringify(template));
          onSaveSuccess("id_card_active_orientation", orientation);
        }
        onHide();
      } else {
        toast.error("Failed to save ID card design.");
      }
    } catch (err) {
      console.error("Error saving card design:", err);
      toast.error(err.response?.data?.message || "Error saving ID card design to backend.");
    } finally {
      setIsSaving(false);
    }
  };

  const handleExportJson = () => {
    const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(template, null, 2));
    const downloadAnchor = document.createElement("a");
    downloadAnchor.setAttribute("href", dataStr);
    downloadAnchor.setAttribute("download", `ID_Card_Template_${orientation}_${moment().format("YYYYMMDD")}.json`);
    document.body.appendChild(downloadAnchor);
    downloadAnchor.click();
    downloadAnchor.remove();
  };

  const handleImportJson = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const parsed = JSON.parse(event.target.result);
        if (parsed && parsed.elements && Array.isArray(parsed.elements)) {
          setTemplate(parsed);
          setOrientation(parsed.orientation || orientation);
          setSelectedElementId(parsed.elements[0]?.id || null);
          toast.success("Template imported successfully!");
        } else {
          toast.error("Invalid template file format.");
        }
      } catch (err) {
        toast.error("Failed to parse JSON file.");
      }
    };
    reader.readAsText(file);
    e.target.value = null; // reset file input
  };

  const updateCardBackground = (updates) => {
    setTemplate((prev) => ({
      ...prev,
      background: {
        ...(prev.background || {}),
        ...updates,
      },
    }));
  };

  const handleBackgroundImageUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      updateCardBackground({ image: reader.result || "" });
      toast.success("Card background image uploaded successfully!");
    };
    reader.readAsDataURL(file);
    e.target.value = null;
  };

  const selectedElement = template.elements.find((el) => el.id === selectedElementId);

  return (
    <Modal show={show} onHide={onHide} size="xl" backdrop="static" keyboard={false} contentClassName="shadow-lg border-0 rounded-3">
      <Modal.Header closeButton className="bg-primary text-white py-3 align-items-center">
        <Modal.Title className="d-flex align-items-center gap-2 fs-5 flex-grow-1">
          <i className="fa-solid fa-wand-magic-sparkles"></i>
          Dynamic ID Card Designer ({orientation.toUpperCase()})
        </Modal.Title>
        <Button
          variant="light"
          size="sm"
          disabled={isSaving}
          onClick={handleSaveToBackend}
          className="px-3 fw-bold text-primary shadow-sm d-flex align-items-center gap-2 me-3"
        >
          {isSaving ? (
            <>
              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Saving...
            </>
          ) : (
            <>
              <i className="fa-solid fa-floppy-disk"></i> Save & Apply Template
            </>
          )}
        </Button>
      </Modal.Header>
      <Modal.Body className="p-0 bg-light" style={{ minHeight: "65vh" }}>
        <Row className="g-0 h-100">
          {/* LEFT PALETTE & CONTROLS (3 Col) */}
          <Col md={3} className="border-end bg-white p-3 d-flex flex-column" style={{ maxHeight: "72vh", overflowY: "auto" }}>
            <h6 className="fw-bold text-uppercase text-secondary mb-3 fs-7">1. Orientation & Presets</h6>
            <div className="d-flex gap-2 mb-3">
              <Button
                variant={orientation === "vertical" ? "primary" : "outline-primary"}
                size="sm"
                className="flex-fill d-flex align-items-center justify-content-center gap-1"
                onClick={() => setOrientation("vertical")}
              >
                <i className="fa-solid fa-mobile-screen"></i> Vertical (54×86)
              </Button>
              <Button
                variant={orientation === "horizontal" ? "primary" : "outline-primary"}
                size="sm"
                className="flex-fill d-flex align-items-center justify-content-center gap-1"
                onClick={() => setOrientation("horizontal")}
              >
                <i className="fa-solid fa-mobile-screen fa-rotate-90"></i> Horizontal (86×54)
              </Button>
            </div>

            <div className="mb-3">
              <Form.Label className="fs-8 fw-bold text-muted mb-1 d-flex align-items-center justify-content-between">
                <span>Layout Theme:</span>
              </Form.Label>
              <Form.Select
                size="sm"
                value={activePresetStyle}
                onChange={(e) => {
                  const selectedStyle = e.target.value;
                  setActivePresetStyle(selectedStyle);
                  const newTpl = getPresetTemplate(selectedStyle, orientation, colorSetting, textColorSetting);
                  setTemplate(newTpl);
                  setSelectedElementId(newTpl.elements[0]?.id || null);
                  
                }}
              >
                <option value="classic">1. Classic Header & Footer (Traditional)</option>
                <option value="minimalist">2. Minimalist Floating Photo (Corporate Clean)</option>
                <option value="sidepanel">3. Modern Split Sidebar (ID Badge Style)</option>
                <option value="gradient_banner">4. Vibrant Accent Banner (Overlapping Photo)</option>
                <option value="hex_gold">5. Gold Accent & Navy Curved Header (Rosie Jenkins Style)</option>
                <option value="dual_gold">6. Split Navy & Gold Frame / Barcode Strip (Hospital/Clinical Style)</option>
              </Form.Select>
              <div className="fs-9 text-muted mt-1">
                Select a theme above as your starting point, then drag and drop below!
              </div>
            </div>

            <Row className="g-2 mb-3">
              <Col xs={6}>
                <Form.Label className="fs-8 text-muted mb-1">Width (mm)</Form.Label>
                <Form.Control
                  type="number"
                  size="sm"
                  value={template.width}
                  onChange={(e) => setTemplate((prev) => ({ ...prev, width: Number(e.target.value) || 54 }))}
                />
              </Col>
              <Col xs={6}>
                <Form.Label className="fs-8 text-muted mb-1">Height (mm)</Form.Label>
                <Form.Control
                  type="number"
                  size="sm"
                  value={template.height}
                  onChange={(e) => setTemplate((prev) => ({ ...prev, height: Number(e.target.value) || 86 }))}
                />
              </Col>
            </Row>

            <div className="d-flex justify-content-between align-items-center mb-3">
              <span className="fs-8 fw-bold text-muted">Canvas Zoom:</span>
              <div className="d-flex align-items-center gap-1">
                <Button variant="outline-secondary" size="sm" style={{ padding: "0 6px" }} onClick={() => setZoom((z) => Math.max(2, z - 0.4))}>
                  <i className="fa-solid fa-minus"></i>
                </Button>
                <span className="fs-8 px-1 fw-semibold">{Math.round(zoom * 26)}%</span>
                <Button variant="outline-secondary" size="sm" style={{ padding: "0 6px" }} onClick={() => setZoom((z) => Math.min(6, z + 0.4))}>
                  <i className="fa-solid fa-plus"></i>
                </Button>
              </div>
            </div>

            <div className="border rounded p-2 bg-light mb-3">
              <Form.Label className="fs-8 fw-bold text-muted mb-2 d-flex align-items-center gap-2">
                <i className="fa-solid fa-image text-primary"></i> Card Background
              </Form.Label>
              <Form.Group className="mb-2">
                <Form.Label className="fs-9 text-muted mb-1">Background Color</Form.Label>
                <div className="d-flex align-items-center gap-2">
                  <Form.Control
                    type="color"
                    size="sm"
                    style={{ width: "42px", height: "32px", padding: "1px" }}
                    value={template.background?.color || "#ffffff"}
                    onChange={(e) => updateCardBackground({ color: e.target.value })}
                  />
                  <span className="fs-8 font-monospace">{template.background?.color || "#ffffff"}</span>
                </div>
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label className="fs-9 text-muted mb-1">Upload Background Image</Form.Label>
                <Form.Control type="file" accept="image/*" size="sm" onChange={handleBackgroundImageUpload} />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label className="fs-9 text-muted mb-1" htmlFor="id-card-background-image-url">Paste background image URL or data URL</Form.Label>
                <Form.Control
                  id="id-card-background-image-url"
                  type="text"
                  size="sm"
                  placeholder="https://... or data:image/..."
                  value={template.background?.image || ""}
                  onChange={(e) => updateCardBackground({ image: e.target.value })}
                />
              </Form.Group>
              {template.background?.image && (
                <div className="d-flex align-items-center justify-content-between pt-1 border-top">
                  <span className="fs-9 text-success fw-semibold"><i className="fa-solid fa-check-circle me-1"></i>Background applied</span>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    style={{ padding: "1px 6px", fontSize: "11px" }}
                    onClick={() => updateCardBackground({ image: "" })}
                  >
                    Remove Image
                  </Button>
                </div>
              )}
            </div>

            <hr className="my-2" />

            <h6 className="fw-bold text-uppercase text-secondary my-3 fs-7">2. Add Elements</h6>
            <div className="d-flex flex-column gap-2 mb-4">
              <DropdownOrList
                onAdd={handleAddElement}
              />
            </div>

            <hr className="my-2" />

            <div className="d-flex justify-content-between align-items-center my-3">
              <h6 className="fw-bold text-uppercase text-secondary my-0 fs-7">3. Sample Preview</h6>
              <div className="btn-group btn-group-sm" role="group">
                <Button
                  variant={previewEntityType === "student" ? "primary" : "outline-primary"}
                  size="sm"
                  style={{ fontSize: "11px", padding: "1px 8px" }}
                  onClick={() => { setPreviewEntityType("student"); setPreviewStudentIndex(0); }}
                >
                  <i className="fa-solid fa-user-graduate me-1"></i> Student
                </Button>
                <Button
                  variant={previewEntityType === "staff" ? "primary" : "outline-primary"}
                  size="sm"
                  style={{ fontSize: "11px", padding: "1px 8px" }}
                  onClick={() => { setPreviewEntityType("staff"); setPreviewStudentIndex(0); }}
                >
                  <i className="fa-solid fa-user-tie me-1"></i> Staff
                </Button>
              </div>
            </div>
            {previewEntityType === "student" && studentList.length > 0 ? (
              <div className="bg-light p-2 rounded border mb-3">
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <span className="fs-8 fw-bold text-primary">{studentInfo.studentname || studentInfo.firstname || "Sample Student"}</span>
                  <Badge bg="secondary" className="fs-8">{previewStudentIndex + 1}/{studentList.length}</Badge>
                </div>
                <div className="fs-8 text-muted mb-2">Class: {studentInfo.class_name || "N/A"} | Reg: {studentInfo.registration_no || studentInfo.srno || "N/A"}</div>
                <div className="d-flex gap-1">
                  <Button
                    variant="outline-primary"
                    size="sm"
                    className="flex-fill py-0 fs-8"
                    disabled={previewStudentIndex <= 0}
                    onClick={() => setPreviewStudentIndex((prev) => prev - 1)}
                  >
                    <i className="fa-solid fa-chevron-left me-1"></i> Prev
                  </Button>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    className="flex-fill py-0 fs-8"
                    disabled={previewStudentIndex >= studentList.length - 1}
                    onClick={() => setPreviewStudentIndex((prev) => prev + 1)}
                  >
                    Next <i className="fa-solid fa-chevron-right ms-1"></i>
                  </Button>
                </div>
              </div>
            ) : previewEntityType === "staff" && staffList.length > 0 ? (
              <div className="bg-light p-2 rounded border mb-3">
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <span className="fs-8 fw-bold text-primary">{studentInfo.staffname || studentInfo.firstname || "Sample Staff"}</span>
                  <Badge bg="info" className="fs-8 text-dark">{previewStudentIndex + 1}/{staffList.length}</Badge>
                </div>
                <div className="fs-8 text-muted mb-2">Role: {studentInfo.designation || studentInfo.recordtype || "N/A"} | Emp ID: {studentInfo.employee_id || "N/A"}</div>
                <div className="d-flex gap-1">
                  <Button
                    variant="outline-primary"
                    size="sm"
                    className="flex-fill py-0 fs-8"
                    disabled={previewStudentIndex <= 0}
                    onClick={() => setPreviewStudentIndex((prev) => prev - 1)}
                  >
                    <i className="fa-solid fa-chevron-left me-1"></i> Prev
                  </Button>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    className="flex-fill py-0 fs-8"
                    disabled={previewStudentIndex >= staffList.length - 1}
                    onClick={() => setPreviewStudentIndex((prev) => prev + 1)}
                  >
                    Next <i className="fa-solid fa-chevron-right ms-1"></i>
                  </Button>
                </div>
              </div>
            ) : (
              <div className="fs-8 text-muted mb-3 bg-light p-2 rounded border">
                Using built-in sample data for live preview.
              </div>
            )}

            <div className="mt-auto pt-2 border-top d-flex flex-column gap-2">
              <Button
                variant="outline-danger"
                size="sm"
                className="w-100 d-flex align-items-center justify-content-center gap-2"
                onClick={() => {
                  if (window.confirm("Reset card design to selected starter preset? Any unsaved changes will be lost.")) {
                    const defaultTpl = getPresetTemplate(activePresetStyle, orientation, colorSetting, textColorSetting);
                    setTemplate(defaultTpl);
                    setSelectedElementId(defaultTpl.elements[0]?.id || null);
                  }
                }}
              >
                <i className="fa-solid fa-rotate-left"></i> Reset to Starter Theme
              </Button>
              <div className="d-flex gap-2">
                <Button variant="outline-secondary" size="sm" className="flex-fill" onClick={handleExportJson}>
                  <i className="fa-solid fa-download me-1"></i> Export JSON
                </Button>
                <Button variant="outline-secondary" size="sm" className="flex-fill" onClick={() => fileInputRef.current?.click()}>
                  <i className="fa-solid fa-upload me-1"></i> Import JSON
                </Button>
                <input type="file" ref={fileInputRef} style={{ display: "none" }} accept=".json" onChange={handleImportJson} />
              </div>
            </div>
          </Col>

          {/* CENTER CANVAS AREA (6 Col) */}
          <Col md={6} className="p-4 d-flex flex-column align-items-center justify-content-center bg-secondary bg-opacity-10" style={{ overflow: "auto", minHeight: "78vh" }}>
            <div className="mb-2 text-muted fs-8 fw-semibold d-flex align-items-center gap-2">
              <i className="fa-solid fa-hand-pointer"></i> Drag elements directly on the card to position. Click to select & style.
            </div>

            {/* CARD CANVAS CONTAINER */}
            <div
              className="shadow-lg position-relative bg-white border"
              style={{
                width: `${template.width * zoom}px`,
                height: `${template.height * zoom}px`,
                borderRadius: "12px",
                overflow: "hidden",
                backgroundImage: template.background.image ? `url(${template.background.image})` : "none",
                backgroundColor: template.background.color || "#ffffff",
                backgroundSize: "cover",
                backgroundPosition: "center",
                boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                userSelect: "none",
              }}
              onClick={(e) => {
                if (e.target === e.currentTarget) {
                  setSelectedElementId(null);
                }
              }}
            >
              {template.elements
                .slice()
                .sort((a, b) => (a.zIndex || 1) - (b.zIndex || 1))
                .filter((element) => !element.entityTarget || element.entityTarget === "all" || element.entityTarget === previewEntityType)
                .filter((element) => !(previewEntityType === "staff" && element.fieldKey === "registrationNo"))
                .map((element) => {
                  const isSelected = element.id === selectedElementId;
                  const elLeft = element.x * zoom;
                  const elTop = element.y * zoom;
                  const elWidth = element.width * zoom;
                  const elHeight = element.height * zoom;

                  const elBorderWidth = Number(element.borderWidth) || 0;
                  const elBorderBottomWidth = Number(element.borderWidthBottom) || 0;
                  const elBorderColor = element.borderColor || "#e5e7eb";
                  const topBorder = elBorderWidth > 0 ? `${elBorderWidth}px solid ${elBorderColor}` : "none";
                  const rightBorder = elBorderWidth > 0 ? `${elBorderWidth}px solid ${elBorderColor}` : "none";
                  const leftBorder = elBorderWidth > 0 ? `${elBorderWidth}px solid ${elBorderColor}` : "none";
                  const bottomBorder = (elBorderBottomWidth > 0 || elBorderWidth > 0)
                    ? `${Math.max(elBorderBottomWidth, elBorderWidth)}px solid ${elBorderColor}`
                    : "none";

                  return (
                    <Draggable
                      key={element.id}
                      position={{ x: elLeft, y: elTop }}
                      onStop={(e, data) => handleDragStop(element.id, e, data)}
                      bounds="parent"
                      onStart={() => setSelectedElementId(element.id)}
                    >
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedElementId(element.id);
                        }}
                        style={{
                          position: "absolute",
                          width: `${elWidth}px`,
                          height: `${elHeight}px`,
                          cursor: "move",
                          zIndex: element.zIndex || 1,
                          outline: isSelected ? "1.5px dashed #0d6efd" : "none",
                          outlineOffset: "1px",
                          boxShadow: isSelected ? "0 0 0 2px rgba(13, 110, 253, 0.25)" : "none",
                          boxSizing: "border-box",
                          overflow: "hidden",
                          display: "flex",
                          alignItems: element.type === "image" ? "center" : "flex-start",
                          justifyContent:
                            element.textAlign === "center"
                              ? "center"
                              : element.textAlign === "right"
                              ? "flex-end"
                              : "flex-start",
                          backgroundColor: element.backgroundColor || "transparent",
                          borderRadius: `${element.borderRadius || 0}${element.borderRadius === 50 ? "%" : "px"}`,
                          borderTop: topBorder,
                          borderRight: rightBorder,
                          borderBottom: bottomBorder,
                          borderLeft: leftBorder,
                          textTransform: element.textTransform || "none",
                        }}
                      >
                        {element.type === "shape" ? (
                          <div style={{ width: "100%", height: "100%" }} />
                        ) : element.type === "image" ? (
                          (() => {
                            if (element.fieldKey === "schoolLogo") {
                              return (
                                <img
                                  src={getLogoUrl()}
                                  alt={element.label}
                                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = "/uploads/dwps_ajmer/image_2024102442318.png";
                                  }}
                                />
                              );
                            } else if (element.fieldKey === "profileImage") {
                              return (
                                <img
                                  src={getProfileImageUrl()}
                                  alt={element.label}
                                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = "/uploads/dwps_ajmer/image_2024102442318.png";
                                  }}
                                />
                              );
                            } else if (element.fieldKey === "principalSignature") {
                              const signUrl = element.imageUrl || (element.text && (element.text.startsWith("data:") || element.text.startsWith("http") || element.text.startsWith("/"))) ? (element.imageUrl || element.text) : "";
                              if (!signUrl) {
                                return (
                                  <div
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      border: "1px dashed #6c757d",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontSize: `${(element.fontSize || 9) * (zoom / 3.8)}px`,
                                      color: "#6c757d",
                                      backgroundColor: "rgba(108, 117, 125, 0.05)",
                                      padding: "2px",
                                      textAlign: "center",
                                    }}
                                  >
                                    Principal Sign. (Click to upload)
                                  </div>
                                );
                              }
                              return (
                                <img
                                  src={signUrl}
                                  alt="Principal Signature"
                                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                />
                              );
                            } else {
                              const customUrl = element.imageUrl || (element.text && (element.text.startsWith("data:") || element.text.startsWith("http") || element.text.startsWith("/"))) ? (element.imageUrl || element.text) : getLogoUrl();
                              return (
                                <img
                                  src={customUrl}
                                  alt={element.label}
                                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = "/uploads/dwps_ajmer/image_2024102442318.png";
                                  }}
                                />
                              );
                            }
                          })()
                        ) : (() => {
                          const applyCase = (text, transform) => {
                            if (!text || typeof text !== "string") return text || "";
                            if (transform === "uppercase") return text.toUpperCase();
                            if (transform === "lowercase") return text.toLowerCase();
                            if (transform === "capitalize") {
                              return text.replace(/\b\w/g, (char) => char.toUpperCase());
                            }
                            return text;
                          };
                          const transform = element.textTransform || "none";
                          const rawVal = applyCase(getFieldValue(element.fieldKey, element), transform);
                          let effectivePrefix = element.prefix || "";
                          if (previewEntityType === "staff") {
                            if (element.fieldKey === "fullClass" && (effectivePrefix.toLowerCase().includes("class") || effectivePrefix === "")) {
                              effectivePrefix = effectivePrefix.includes(":") ? "Role : " : "Role: ";
                            } else if (element.fieldKey === "fatherName" && effectivePrefix.toLowerCase().includes("father")) {
                              effectivePrefix = effectivePrefix.includes(":") ? "Dept/Qual : " : "Dept: ";
                            } else if (element.fieldKey === "registrationNo" && (effectivePrefix.toLowerCase().includes("reg") || effectivePrefix.toLowerCase().includes("roll"))) {
                              effectivePrefix = effectivePrefix.includes(":") ? "Emp ID : " : "Emp ID: ";
                            }
                          }
                          const prefixStr = applyCase(effectivePrefix || "", transform);
                          const suffixStr = applyCase(element.suffix || "", transform);
                          const hasColon = prefixStr.includes(":");
                          const isTableRowOrHasPrefix = prefixStr.trim().length > 0;
                          const isMultiLine = element.fieldKey?.toLowerCase().includes("address") || Number(element.height) > 5.5 || element.wordBreak === "break-word";

                          if (isTableRowOrHasPrefix && (hasColon || Number(element.borderWidthBottom) > 0)) {
                            const labelText = hasColon
                              ? prefixStr.substring(0, prefixStr.indexOf(":")).trim()
                              : prefixStr.trim();
                            const colonDisplay = hasColon ? ":" : (Number(element.borderWidthBottom) > 0 && labelText ? ":" : "");

                            return (
                              <div
                                style={{
                                  display: "flex",
                                  width: "100%",
                                  height: "100%",
                                  alignItems: "flex-start",
                                  fontSize: `${element.fontSize * (zoom / 3.8)}px`,
                                  fontWeight: element.fontWeight || "normal",
                                  color: element.color || "#000000",
                                  fontFamily: element.fontFamily || "Arial, sans-serif",
                                  lineHeight: 1.18,
                                  padding: "1px 2px",
                                  boxSizing: "border-box",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "37%",
                                    flexShrink: 0,
                                    paddingRight: "6px",
                                    boxSizing: "border-box",
                                    fontSize: `${element.fontSize * (zoom / 3.8)}px`,
                                    fontWeight: element.fontWeight || "normal",
                                    color: element.color || "#000000",
                                    fontFamily: element.fontFamily || "Arial, sans-serif",
                                  }}
                                >
                                  <span
                                    style={{
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      fontSize: `${element.fontSize * (zoom / 3.8)}px`,
                                      fontWeight: element.fontWeight || "normal",
                                      color: element.color || "#000000",
                                      fontFamily: element.fontFamily || "Arial, sans-serif",
                                    }}
                                  >
                                    {labelText}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: `${element.fontSize * (zoom / 3.8)}px`,
                                      fontWeight: element.fontWeight || "normal",
                                      color: element.color || "#000000",
                                      fontFamily: element.fontFamily || "Arial, sans-serif",
                                    }}
                                  >
                                    {colonDisplay}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    flex: 1,
                                    wordBreak: isMultiLine ? "break-word" : "normal",
                                    whiteSpace: isMultiLine ? "normal" : "nowrap",
                                    overflow: "hidden",
                                    textOverflow: isMultiLine ? "clip" : "ellipsis",
                                    paddingLeft: "2px",
                                    boxSizing: "border-box",
                                    fontSize: `${element.fontSize * (zoom / 3.8)}px`,
                                    fontWeight: element.fontWeight || "normal",
                                    color: element.color || "#000000",
                                    fontFamily: element.fontFamily || "Arial, sans-serif",
                                  }}
                                >
                                  {rawVal}{suffixStr}
                                </div>
                              </div>
                            );
                          } else {
                            return (
                              <div
                                style={{
                                  fontSize: `${element.fontSize * (zoom / 3.8)}px`,
                                  fontWeight: element.fontWeight || "normal",
                                  color: element.color || "#000000",
                                  textAlign: element.textAlign || "left",
                                  fontFamily: element.fontFamily || "Arial, sans-serif",
                                  width: "100%",
                                  wordBreak: isMultiLine ? "break-word" : "normal",
                                  whiteSpace: isMultiLine ? "normal" : "nowrap",
                                  textOverflow: isMultiLine ? "clip" : "ellipsis",
                                  lineHeight: 1.15,
                                  padding: "1px 2px",
                                  boxSizing: "border-box",
                                }}
                              >
                                {prefixStr}{rawVal}{suffixStr}
                              </div>
                            );
                          }
                        })()}
                      </div>
                    </Draggable>
                  );
                })}
            </div>
          </Col>

          {/* RIGHT INSPECTOR PANEL (3 Col) */}
          <Col md={3} className="border-start bg-white p-3 d-flex flex-column" style={{ maxHeight: "72vh", overflowY: "auto" }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="fw-bold text-uppercase text-secondary mb-0 fs-7">4. Element Properties</h6>
              <Button
                variant="primary"
                size="sm"
                disabled={isSaving}
                onClick={handleSaveToBackend}
                className="d-flex align-items-center gap-1 fs-8 px-2 shadow-sm"
                title="Save & Apply Template to all student cards"
              >
                <i className="fa-solid fa-floppy-disk"></i> Save Theme
              </Button>
            </div>
            {selectedElement ? (
              <Form className="d-flex flex-column gap-3">
                <div className="d-flex justify-content-between align-items-center bg-light p-2 rounded border">
                  <span className="fw-bold text-primary fs-8 text-truncate">{selectedElement.label}</span>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    className="py-0 px-2 fs-8"
                    onClick={() => handleDeleteElement(selectedElement.id)}
                  >
                    <i className="fa-solid fa-trash"></i> Delete
                  </Button>
                </div>

                {/* IMAGE & SIGNATURE UPLOAD */}
                {(selectedElement.type === "image" || selectedElement.fieldKey === "principalSignature" || selectedElement.label?.toLowerCase().includes("principal") || selectedElement.text?.toLowerCase().includes("principal")) && (
                  <div className="border rounded p-2 bg-light shadow-sm">
                    <Form.Label className="fs-8 fw-bold text-dark mb-1 d-flex align-items-center justify-content-between">
                      <span><i className="fa-solid fa-signature me-1 text-primary"></i>Image & Signature Upload</span>
                      <span className="badge bg-white text-dark border font-monospace fs-9">{selectedElement.fieldKey || selectedElement.type}</span>
                    </Form.Label>
                    <Form.Group className="mb-2">
                      <Form.Label className="fs-9 text-muted mb-1">Upload Signature / Image File (.png, .jpg)</Form.Label>
                      <Form.Control
                        type="file"
                        accept="image/*"
                        size="sm"
                        onChange={(e) => {
                          const file = e.target.files?.[0];
                          if (file) {
                            const reader = new FileReader();
                            reader.onloadend = () => {
                              const base64Data = reader.result;
                              handleElementPropertiesChange({
                                type: "image",
                                fieldKey: selectedElement.fieldKey || "principalSignature",
                                imageUrl: base64Data,
                                text: base64Data,
                                borderWidth: selectedElement.type === "image" && selectedElement.fieldKey !== "principalSignature" ? selectedElement.borderWidth : 0,
                                borderRadius: selectedElement.type === "image" && selectedElement.fieldKey !== "principalSignature" ? selectedElement.borderRadius : 0,
                              });
                              toast.success("Image / Signature uploaded successfully!");
                            };
                            reader.readAsDataURL(file);
                          }
                        }}
                      />
                    </Form.Group>
                    <Form.Group className="mb-1">
                      <Form.Label className="fs-9 text-muted mb-1">Or Paste Image URL / Base64</Form.Label>
                      <Form.Control
                        type="text"
                        size="sm"
                        placeholder="https://... or data:image/..."
                        value={selectedElement.imageUrl || (selectedElement.text && (selectedElement.text.startsWith("data:") || selectedElement.text.startsWith("http") || selectedElement.text.startsWith("/")) ? selectedElement.text : "")}
                        onChange={(e) => {
                          const val = e.target.value;
                          handleElementPropertiesChange({
                            type: "image",
                            fieldKey: selectedElement.fieldKey || "principalSignature",
                            imageUrl: val,
                            text: val,
                          });
                        }}
                      />
                    </Form.Group>
                    {(selectedElement.imageUrl || (selectedElement.text && (selectedElement.text.startsWith("data:") || selectedElement.text.startsWith("http") || selectedElement.text.startsWith("/")))) && (
                      <div className="mt-2 pt-1 border-top d-flex align-items-center justify-content-between">
                        <span className="fs-9 text-success fw-semibold"><i className="fa-solid fa-check-circle me-1"></i>Image Applied</span>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          style={{ padding: "1px 6px", fontSize: "11px" }}
                          onClick={() => {
                            handleElementPropertiesChange({
                              imageUrl: "",
                              text: selectedElement.fieldKey === "principalSignature" ? "Principal Sign." : "",
                            });
                          }}
                        >
                          Remove Image
                        </Button>
                      </div>
                    )}
                  </div>
                )}

                {/* POSITION & SIZE */}
                <div>
                  <Form.Label className="fs-8 fw-bold text-muted mb-1">Position & Size (mm)</Form.Label>
                  <Row className="g-2">
                    <Col xs={6}>
                      <Form.Label className="fs-9 text-muted mb-0">Left (X)</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.5"
                        size="sm"
                        value={selectedElement.x}
                        onChange={(e) => handleElementPropertyChange("x", Number(e.target.value) || 0)}
                      />
                    </Col>
                    <Col xs={6}>
                      <Form.Label className="fs-9 text-muted mb-0">Top (Y)</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.5"
                        size="sm"
                        value={selectedElement.y}
                        onChange={(e) => handleElementPropertyChange("y", Number(e.target.value) || 0)}
                      />
                    </Col>
                    <Col xs={6}>
                      <Form.Label className="fs-9 text-muted mb-0">Width</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.5"
                        size="sm"
                        value={selectedElement.width}
                        onChange={(e) => handleElementPropertyChange("width", Number(e.target.value) || 1)}
                      />
                    </Col>
                    <Col xs={6}>
                      <Form.Label className="fs-9 text-muted mb-0">Height</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.5"
                        size="sm"
                        value={selectedElement.height}
                        onChange={(e) => handleElementPropertyChange("height", Number(e.target.value) || 1)}
                      />
                    </Col>
                  </Row>
                </div>

                {/* TEXT & PREFIX (For fields/texts) */}
                {(selectedElement.type === "field" || selectedElement.type === "text") && (
                  <div>
                    {selectedElement.type === "text" ? (
                      <Form.Group className="mb-2">
                        <Form.Label className="fs-8 fw-bold text-muted mb-1">Text Content</Form.Label>
                        <Form.Control
                          type="text"
                          size="sm"
                          value={selectedElement.text || ""}
                          onChange={(e) => handleElementPropertyChange("text", e.target.value)}
                        />
                      </Form.Group>
                    ) : (
                      <Form.Group className="mb-2">
                        <Form.Label className="fs-8 fw-bold text-muted mb-1">Label Prefix (e.g. "DOB : ")</Form.Label>
                        <Form.Control
                          type="text"
                          size="sm"
                          placeholder="Prefix..."
                          value={selectedElement.prefix || ""}
                          onChange={(e) => handleElementPropertyChange("prefix", e.target.value)}
                        />
                      </Form.Group>
                    )}

                    <Form.Label className="fs-8 fw-bold text-muted mb-1">Typography</Form.Label>
                    <Row className="g-2 mb-2">
                      <Col xs={6}>
                        <Form.Label className="fs-9 text-muted mb-0">Font Size (px)</Form.Label>
                        <Form.Control
                          type="number"
                          size="sm"
                          value={selectedElement.fontSize || 10}
                          onChange={(e) => handleElementPropertyChange("fontSize", Number(e.target.value) || 8)}
                        />
                      </Col>
                      <Col xs={6}>
                        <Form.Label className="fs-9 text-muted mb-0">Weight</Form.Label>
                        <Form.Select
                          size="sm"
                          value={selectedElement.fontWeight || "normal"}
                          onChange={(e) => handleElementPropertyChange("fontWeight", e.target.value)}
                        >
                          <option value="normal">Normal</option>
                          <option value="bold">Bold</option>
                        </Form.Select>
                      </Col>
                    </Row>
                    <Row className="g-2 mb-2 align-items-center">
                      <Col xs={6}>
                        <Form.Label className="fs-9 text-muted mb-0">Text Color</Form.Label>
                        <div className="d-flex align-items-center gap-1">
                          <Form.Control
                            type="color"
                            size="sm"
                            style={{ width: "36px", height: "30px", padding: "1px" }}
                            value={selectedElement.color || "#000000"}
                            onChange={(e) => handleElementPropertyChange("color", e.target.value)}
                          />
                          <span className="fs-9 font-monospace text-muted">{selectedElement.color}</span>
                        </div>
                      </Col>
                      <Col xs={6}>
                        <Form.Label className="fs-9 text-muted mb-0">Alignment</Form.Label>
                        <Form.Select
                          size="sm"
                          value={selectedElement.textAlign || "left"}
                          onChange={(e) => handleElementPropertyChange("textAlign", e.target.value)}
                        >
                          <option value="left">Left</option>
                          <option value="center">Center</option>
                          <option value="right">Right</option>
                        </Form.Select>
                      </Col>
                    </Row>
                    <Row className="g-2 mb-2 align-items-center">
                      <Col xs={12}>
                        <Form.Label className="fs-9 text-muted mb-0">Text Case</Form.Label>
                        <Form.Select
                          size="sm"
                          value={selectedElement.textTransform || "none"}
                          onChange={(e) => handleElementPropertyChange("textTransform", e.target.value)}
                        >
                          <option value="none">Normal (Default)</option>
                          <option value="uppercase">UPPERCASE</option>
                          <option value="lowercase">lowercase</option>
                          <option value="capitalize">Capitalize Each Word</option>
                        </Form.Select>
                      </Col>
                    </Row>
                  </div>
                )}

                {/* BACKGROUND & BORDERS */}
                <div>
                  {selectedElement.type === "shape" && (
                    <Form.Group className="mb-2">
                      <Form.Label className="fs-8 fw-bold text-muted mb-1">Background Color</Form.Label>
                      <div className="d-flex align-items-center gap-2">
                        <Form.Control
                          type="color"
                          size="sm"
                          style={{ width: "42px", height: "32px", padding: "1px" }}
                          value={selectedElement.backgroundColor || "#d1b2b2"}
                          onChange={(e) => handleElementPropertyChange("backgroundColor", e.target.value)}
                        />
                        <span className="fs-8 font-monospace">{selectedElement.backgroundColor}</span>
                      </div>
                    </Form.Group>
                  )}

                  <Form.Label className="fs-8 fw-bold text-muted mb-1 mt-2">Border & Divider Styling</Form.Label>
                  <Row className="g-2 mb-2">
                    <Col xs={3}>
                      <Form.Label className="fs-9 text-muted mb-0" title="Full All-Around Border">Box Border</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.5"
                        size="sm"
                        value={selectedElement.borderWidth || 0}
                        onChange={(e) => handleElementPropertyChange("borderWidth", Number(e.target.value) || 0)}
                      />
                    </Col>
                    <Col xs={3}>
                      <Form.Label className="fs-9 text-muted mb-0" title="Bottom Divider Line Width">Bottom Line</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.5"
                        size="sm"
                        value={selectedElement.borderWidthBottom || 0}
                        onChange={(e) => handleElementPropertyChange("borderWidthBottom", Number(e.target.value) || 0)}
                      />
                    </Col>
                    <Col xs={3}>
                      <Form.Label className="fs-9 text-muted mb-0">Radius</Form.Label>
                      <Form.Control
                        type="number"
                        size="sm"
                        value={selectedElement.borderRadius || 0}
                        onChange={(e) => handleElementPropertyChange("borderRadius", Number(e.target.value) || 0)}
                      />
                    </Col>
                    <Col xs={3}>
                      <Form.Label className="fs-9 text-muted mb-0">Color</Form.Label>
                      <Form.Control
                        type="color"
                        size="sm"
                        style={{ width: "100%", height: "28px", padding: "1px" }}
                        value={selectedElement.borderColor || "#e5e7eb"}
                        onChange={(e) => handleElementPropertyChange("borderColor", e.target.value)}
                      />
                    </Col>
                  </Row>
                </div>

                {/* TARGET ENTITY (UNIVERSAL / STUDENT / STAFF) */}
                <div className="mb-2">
                  <Form.Label className="fs-8 fw-bold text-muted mb-1" title="Choose whether this element appears on both student and staff cards, or only on one type">Target Entity (Visibility)</Form.Label>
                  <Form.Select
                    size="sm"
                    value={selectedElement.entityTarget || "all"}
                    onChange={(e) => handleElementPropertyChange("entityTarget", e.target.value)}
                  >
                    <option value="all">All Cards (Universal Default)</option>
                    <option value="student">Students Only</option>
                    <option value="staff">Staff / Employees Only</option>
                  </Form.Select>
                </div>

                {/* LAYERING (Z-Index) */}
                <div>
                  <Form.Label className="fs-8 fw-bold text-muted mb-1">Layer Priority (Z-Index)</Form.Label>
                  <Form.Control
                    type="number"
                    size="sm"
                    value={selectedElement.zIndex || 1}
                    onChange={(e) => handleElementPropertyChange("zIndex", Number(e.target.value) || 1)}
                  />
                </div>
              </Form>
            ) : (
              <div className="text-center text-muted py-5 my-auto">
                <i className="fa-solid fa-layer-group fs-2 mb-2 text-secondary"></i>
                <div className="fs-8">No element selected. Click an element on the canvas to edit its properties.</div>
              </div>
            )}
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="bg-light py-2 px-4 border-top">
      </Modal.Footer>
    </Modal>
  );
};

// Helper component to add elements quickly
const DropdownOrList = ({ onAdd }) => {
  return (
    <div className="d-flex flex-column gap-2" style={{ maxHeight: "60vh", overflowY: "auto", paddingRight: "4px" }}>
      <div className="fs-8 fw-bold text-primary mb-0">1. Student Personal Fields:</div>
      <Row className="g-1">
        <Col xs={6}>
          <Button variant="outline-primary" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("field", "studentName", "Student Name")}>
            <i className="fa-solid fa-user me-1"></i> Student Name
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-primary" size="sm" className="w-100 fs-8 text-start text-truncate" title="Student Home Address" onClick={() => onAdd("field", "studentAddress", "Student Address")}>
            <i className="fa-solid fa-house-user me-1"></i> Student Address
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-primary" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("field", "fullClass", "Class & Section")}>
            <i className="fa-solid fa-graduation-cap me-1"></i> Class & Sec
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-primary" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("field", "fatherName", "Father's Name")}>
            <i className="fa-solid fa-user-tie me-1"></i> Father Name
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-primary" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("field", "registerDate", "Date of Birth")}>
            <i className="fa-solid fa-calendar me-1"></i> Date of Birth
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-primary" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("field", "phone", "Contact Phone")}>
            <i className="fa-solid fa-phone me-1"></i> Contact Phone
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-primary" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("field", "registrationNo", "Reg / ID No")}>
            <i className="fa-solid fa-id-card me-1"></i> Reg / ID No
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-primary" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("field", "bloodGroup", "Blood Group")}>
            <i className="fa-solid fa-droplet me-1"></i> Blood Group
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-primary" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("field", "adharnumber", "Aadhar No")}>
            <i className="fa-solid fa-fingerprint me-1"></i> Aadhar No
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-primary" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("field", "session", "Session Year")}>
            <i className="fa-solid fa-calendar-check me-1"></i> Session Year
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-primary" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("field", "gender", "Gender")}>
            <i className="fa-solid fa-venus-mars me-1"></i> Gender
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-primary" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("field", "category", "Category")}>
            <i className="fa-solid fa-tags me-1"></i> Category
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-primary" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("field", "srno", "Roll / Sr No")}>
            <i className="fa-solid fa-hashtag me-1"></i> Roll / Sr No
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-primary" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("field", "email", "Email Address")}>
            <i className="fa-solid fa-envelope me-1"></i> Student Email
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-primary" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("field", "city", "City")}>
            <i className="fa-solid fa-city me-1"></i> City
          </Button>
        </Col>
      </Row>

      <div className="fs-8 fw-bold text-info mt-2 mb-0">2. Staff / Employee Specific Fields:</div>
      <Row className="g-1">
        <Col xs={6}>
          <Button variant="outline-info" size="sm" className="w-100 fs-8 text-start text-truncate text-dark" onClick={() => onAdd("field", "designation", "Role / Designation")}>
            <i className="fa-solid fa-user-tie me-1"></i> Role / Designation
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-info" size="sm" className="w-100 fs-8 text-start text-truncate text-dark" onClick={() => onAdd("field", "qualification", "Qualification / Dept")}>
            <i className="fa-solid fa-building me-1"></i> Department / Qual
          </Button>
        </Col>
      </Row>

      <div className="fs-8 fw-bold text-success mt-2 mb-0">3. School Details:</div>
      <Row className="g-1">
        <Col xs={6}>
          <Button variant="outline-success" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("field", "schoolName", "School Name")}>
            <i className="fa-solid fa-school me-1"></i> School Name
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-success" size="sm" className="w-100 fs-8 text-start text-truncate" title="School Address" onClick={() => onAdd("field", "schoolAddress", "School Address")}>
            <i className="fa-solid fa-location-dot me-1"></i> School Address
          </Button>
        </Col>
        <Col xs={12}>
          <Button variant="outline-success" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("field", "schoolPhone", "School Phone")}>
            <i className="fa-solid fa-phone-volume me-1"></i> School Phone No.
          </Button>
        </Col>
      </Row>

      <div className="fs-8 fw-bold text-dark mt-2 mb-0">4. Images & Shapes:</div>
      <Row className="g-1">
        <Col xs={6}>
          <Button variant="outline-dark" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("image", "profileImage", "Student Photo")}>
            <i className="fa-solid fa-camera me-1"></i> Student Photo
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-dark" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("image", "schoolLogo", "School Logo")}>
            <i className="fa-solid fa-shield-halved me-1"></i> School Logo
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-dark" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("image", "principalSignature", "Principal Sign.")}>
            <i className="fa-solid fa-signature me-1"></i> Principal Sign.
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-dark" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("image", "customImage", "Custom Image")}>
            <i className="fa-solid fa-image me-1"></i> Custom Image
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-secondary" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("text", "", "Custom Text")}>
            <i className="fa-solid fa-font me-1"></i> Custom Text
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant="outline-secondary" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("shape", "", "Shape / Box")}>
            <i className="fa-solid fa-square me-1"></i> Color Box
          </Button>
        </Col>
          <Col xs={6}>
          <Button variant="outline-dark" size="sm" className="w-100 fs-8 text-start text-truncate" onClick={() => onAdd("image", "profileImage", "Student Photo")}>
            <i className="fa-solid fa-camera me-1"></i> Staff Image
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default IdCardDesignerModal;
